<template>
    <div class="position-relative" style="z-index: 1;">
        <template v-if="events.length<=0">
            <draggable
                ghost-class="ghost"
                group="appointments"
                :list="events"
                @change="change($event, date)"
                :move="move"
                @start="startDragging()"
                @end="dragging = false"
            ></draggable>
        </template>
        <template v-else>
            <component
                @start="startDragging()"
                @end="dragging = false"
                ghost-class="ghost"
                :is="drag"
                group="appointments"
                :list="events"
            >
                <div v-for="(event, index) in events" :key="index" class="eventItem" :class="{singleMember:singleMember}">
                    <div
                        :id="id(event)"
                        class="card event"
                        :style="eventClass(duration(event.startAt, event.endAt), event)"
                    >
                        <div
                            class="row pl-1"
                            :style="' border-bottom:1px solid '+event.colors +'; background-color: ' + event.colors "
                        >
                            <div class="col text-left pr-0">
                                <span class="small block" v-if="event.customer">
                                    <!-- <avatar :src="event.customer.avatar.preview" type="circle" v-if="event.customer" size="avatar-xs"></avatar> -->
                                    {{ event.customer.first_name }}
                                    {{ event.customer.last_name }}
                                    <i
                                        class="fe fe-dollar-sign small text-white"
                                        v-if="event.customer.balance<0"
                                    />
                                    <!-- {{ event.startAt | moment("LT")}}-{{ event.endAt | moment("LT")}} -->
                                </span>
                            </div>
                            <div class="col-auto mr-1 pt-1">
                                <div class="bg-white whiteCircle">
                                    <status-badge :status="event.status" :iconOnly="true" :noBadge="true"></status-badge>
                                </div>
                            </div>
                        </div>

                        <div class="card-body p-1 m-0 text-left small bg-white" v-if="event.customer">
                            <popover :id="id(event)" :event="event" showDate></popover>
                            <div class="row align-items-center">
                                <div class="col card-text small" style="font-size:12px;">
                                    <div v-for="(service, serviceIndex ) in event.services" :key="serviceIndex">
                                        <span v-if="service.user">
                                            <span v-if="service.treatment">{{ service.treatment.label }}</span>
                                        </span>
                                    </div>
                                    <span class="text-muted">{{ event.notes }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </component>
        </template>
    </div>
</template>

<script>
import Avatar from '@/components/Avatar.vue';
import duration from '@/filters/duration.js';
import draggable from 'vuedraggable'
import StatusBadge from '@/components/StatusBadge';
import {modalMixins} from "@/mixins/modal.js";
import Popover from './Popover.vue'

export default {
    props: {
        events: Array,
        clickEvent: Function,
        date: null,
        change: Function,
        move: Function,
        singleMember: Boolean,
        step: Number,
        lineHeight: Number,
        lineWidth: Number,
    },
    filters: { duration },
    mixins: [modalMixins],
    components: {
        draggable,
        Avatar,
        StatusBadge,
        Popover
    },
    computed: {
        statusList() {
            return statusList;
        },
        drag() {
            // let check = this.$checkDevice();
            // if (check) {
            //     return 'div';
            // }
            // return 'draggable';
            return 'div';
        },
        leftMargins() {
            let result = {}
            Object.values(this.$groupBy(this.events, event => event.startAt)).forEach(group => {
                group.forEach((event, index) => {
                    const baseMargin = Math.floor((this.lineWidth / 2) / group.length);
                    result[event._id] = baseMargin * index
                })
            })
            return result
        }
    },
    data() {
        return {
            draggable: false,
            dragging: false,
        }
    },
    methods: {
        editAppointment(event) {
            let appointment = {
                model: event,
                _id: 'temp'
            };
            const { Appointment } = this.$FeathersVuex
            new Appointment(appointment);

            this.openModal({ id: 'AppointmentFastModal' });
        },
        startDragging() {
            this.dragging = true;
            this.$root.$emit('bv::hide::popover');
        },

        id(event) {
            return 'popupover-inWaitingList-' + event._id;
        },

        eventClass(duration, event) {
            let styles = [];
            styles.push('height: auto');
            styles.push('margin: auto');
            styles.push('max-width: 100%');
            styles.push('border:1px solid ' + event.colors);
            return styles.join(';')
        },
        duration(start, end) {
            let startTime = this.$moment(start);
            let endTime = this.$moment(end);
            return endTime.diff(startTime, 'minutes');
        }
    }
}
</script>

<style lang="scss" scoped>
.whiteCircle {
    height: 20px;
    width: 20px;
    background-color: #bbb;
    border-radius: 50%;
    display: inline-block;
    padding-bottom: 3px;
    span {
        position: relative;
        top: -1px;
        left: 2.5px;
    }
}

.singleMember .event {
    width: 100% !important;
}

.event {
    position: relative;
    width: 100%;
    overflow: hidden;
    margin-bottom: 30px;
}

.user-1 {
    background-color: #ffefe6;
}

.event .badge {
    display: block;
    text-align: left;
    font-size: 12px;
}

//[class^="event-"], [class*=" event-"] {
//    border-left: 2px solid #fff !important;
//}

.eventMultiple {
    // border-radius: 15px;
    position: absolute;
    // width: 28px;
    // overflow: hidden;
}

.eventItem {
    margin-bottom: 20px;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
</style>
